import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Link, useNavigate } from "react-router-dom";

export const NeedToSMSVerifyModal = () => {
  const navigate = useNavigate();

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <Dialog open={true}>
      <DialogContent className="[&>button]:hidden py-12 w-[350px] md:w-[450px] h-[351px] ring-0 ring-transparent">
        <DialogTitle className="dialog-content text-black text-center font-Inter text-xl font-semibold leading-[30px] max-w-[287px] mx-auto">
          <p>SMS認証が必要です</p>
        </DialogTitle>

        <p className="text-center text-md text-gray-500">
          出金機能をご利用いただくには、
          <br />
          電話番号の認証が必要です。
        </p>

        <div className="flex flex-col w-full items-center justify-center">
          <Link
            to="/sms-registration"
            className="text-lg w-full py-4 text-white rounded-lg font-bold bg-primary text-center"
          >
            電話番号の認証をする
          </Link>

          <button
            type="button"
            onClick={handleBackButtonClick}
            className="text-md w-full py-4 mt-2 text-primary bg-gray-200 text-center border-none hover:border-none"
          >
            戻る
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
